import type { ReactNode } from 'react'

import { EmptyState, Panel } from '../../ui/primitives'

/**
 * Собираемые коллекции с прогрессом, отметка наличия по сетке, дубли и нужные.
 *
 * Экран-заготовка: разметка и место под данные есть, загрузка из API
 * появится вместе с наполнением каталога.
 */
export function MyCollectionScreen(): ReactNode {
  return (
    <section>
      <h1>Моя коллекция</h1>
      <Panel>
        <EmptyState text="Пока пусто" />
      </Panel>
    </section>
  )
}
